<template>
  <gh-table-page ref="table" :tabs="tabs" :show-tabs="false" :args-query="args" module="mes.business.sys.chart.service"
    cls="TemplateManager" :before-save="beforeSave" @start-query="$refs.tree.query()">
    <template #area_left>
      <gh-business-tree ref="tree" v-model="selectedNode" module="mes.business.sys.chart.service" cls="TemplateManager"
        :showToolbar="false" :accordion="false" :draggable="false" :expand-on-click-node="false"
        :default-expand-all="true">
        <template v-slot="{node,data}">
          <span>{{data.Ctrl}}|{{data.Name}}</span>
        </template>
      </gh-business-tree>
    </template>
    <template #area_query>
      <v-layout row align-center v-if="selectedNode.data">
        <span class="header">当前节点：<strong style="color: green">{{selectedNode.data.Ctrl}}</strong> |
          <strong>{{selectedNode.data.Name}}</strong></span>
      </v-layout>
    </template>


  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import Template from "./template.ts";
  export default Template;
</script>